import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { MachineGroupCalendarDay } from '../calendar/machine-group-calendar-day';
import { MachineGroupScheduleTimeRangeBuilder } from './machine-group-schedule-time-range.builder';

export class MachineGroupCalendarDayBuilder {
  static fromJson(json) {
    return (json)
      ? new MachineGroupCalendarDay(
        json.date,
        json.timeRanges ? MachineGroupScheduleTimeRangeBuilder.fromList(sortByNumber('startTime', json.timeRanges)) : [],
        json.colors ? json.colors : []
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ?
      sortByNumber('date', mapCollection(MachineGroupCalendarDayBuilder.fromJson, list)) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/machine-group-calendar-day.builder.ts